import { format } from 'date-fns'
import { ref } from 'vue'

import { ORDERS } from '@/constants/domain/orders'

function createDefaultStatusFilter() {
    return Object.values(ORDERS.COOPERATION_ORDER_STATUS)
        .filter((id) => id !== ORDERS.COOPERATION_ORDER_STATUS.SENT)
        .join(',')
}

function createInitialFilters() {
    return {
        status_id: createDefaultStatusFilter(),
        plannedSendDate__gte: format(new Date(), 'yyyy-MM-dd'),
        plannedSendDate__lte: format(new Date(), 'yyyy-MM-dd'),
        showWithCooperantNumber: false,
        search: null
    }
}

export function createCooperantOrdersState() {
    return {
        orders: ref([]),
        ordersLoading: ref(false),
        filters: ref(createInitialFilters()),
        cooperantDeliveryStatusNames: ref([]),
        orderStatuses: ref([]),
        orderLookups: ref([]),
        orderLookupOrderNumbers: ref([]),
        orderLookupsError: ref(false),
        initialOrderError: ref(false),
        initialOrderErrorId: ref(null),
        deliveryStatusesError: ref(false),
        order: ref(null),
        createInitialFilters
    }
}
